// Animaciones compartidas.
//
// Un `@keyframes` escrito a mano dentro de un styled component declara un nombre
// GLOBAL: styled-components hashea la clase, no el nombre de la animación. Si dos
// componentes definen `spin` con distinta duración u origen, el que gane depende
// del orden de inyección de las hojas — que cambia según qué pantalla se montó
// primero — y el giro sale saltado o arrancado desde un ángulo incorrecto.
//
// El helper `keyframes` genera un nombre único por definición. Usar estos, nunca
// un `@keyframes` suelto dentro de un componente.
import { keyframes } from 'styled-components';

export const spin = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;
